export const isValidAge = (year: number, month: number, day: number) => {
  const birthday = new Date(year, month, day);
  const today = new Date();

  if (isNaN(birthday.getTime())) return null;

  // Weird, but properly handles leap years
  if (today.getFullYear() - birthday.getFullYear() > 13) return true;
  if (today.getFullYear() - birthday.getFullYear() < 13) return false;
  if (today.getMonth() - birthday.getMonth() < 0) return true;
  if (today.getDate() - birthday.getDate() < 0) return true;

  return false;
};
